// extracted by mini-css-extract-plugin
module.exports = {"doughnut":"A0rXSW","green":"c7dQh1_","gray":"xxdoUk"};